import {Component, DoCheck} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {MessageService} from '../../common/service/message.service';
import {PDF_CREATION_METHOD} from '../../common/constants';
import {NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {PermissionsService} from '../../common/service/permissions.service';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';

@Component({
    selector: 'staged-subdivision',
    imports: [NgClass, FormsModule, NlrFormFieldHasErrorPipe],
    templateUrl: './staged-subdivision.component.html',
    styleUrl: './staged-subdivision.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class StagedSubdivisionComponent implements DoCheck {
    title = 'Staged subdivision';

    informationPermissions = ['EDIT_INFORMATION', 'VIEW_INFORMATION'];

    certificationPermissions = ['EDIT_CERTIFICATION', 'VIEW_CERTIFICATION'];

    constructor(
        private permissionsService: PermissionsService,
        private planModelService: PlanModelService,
        private messageService: MessageService
    ) {}

    ngDoCheck(): void {
        if (this.#isMessageDefined() === false) {
            const strata = this.getStrata();
            if (strata) {
                // If there isn't a staged subdivision plan message anymore, clear the strata configuration.
                strata.resubdivisionCompliesWithSchedule = false;
                strata.bylawReferences = undefined;
            }
        }
    }

    resubdivisionCompliesWithScheduleHandler() {
        return (
            !this.planModelService.readonly &&
            (this.getStrata().resubdivisionCompliesWithSchedule = !this.getStrata().resubdivisionCompliesWithSchedule)
        );
    }

    getStrata() {
        return this.planModelService.getModel().strata;
    }

    showComponent() {
        const pdfCreationMethod = this.planModelService.getModel().pdfCreationMethod;
        return (
            (pdfCreationMethod === PDF_CREATION_METHOD.DIGITAL_PLAN || pdfCreationMethod === PDF_CREATION_METHOD.SURVEYOR_PORTAL) &&
            this.#isMessageDefined()
        );
    }

    showResubdivisionCompliesWithSchedule(): boolean {
        return this.permissionsService.hasPermission(this.informationPermissions);
    }

    isResubdivisionCompliesWithScheduleDisabled(): boolean {
        return this.planModelService.readonly || !this.permissionsService.hasEditPermission(this.informationPermissions);
    }

    showBylawReferences(): boolean {
        return this.getStrata()?.resubdivisionCompliesWithSchedule && this.permissionsService.hasPermission(this.certificationPermissions);
    }

    isBylawReferencesDisabled(): boolean {
        return this.planModelService.readonly || !this.permissionsService.hasEditPermission(this.certificationPermissions);
    }

    #isMessageDefined() {
        return this.messageService.isMessageDefined('certification.staged-subdivision');
    }
}
